<template>
  <header class="is-flex is-justify-content-space-between is-align-content-center mb-4">
    <div class="is-flex is-align-items-center">
      <figure class="image is-24x24 mr-2">
        <img :src="props.service.logo_url" />
      </figure>
      <h4 class="has-text-dark has-text-weight-bold is-size-4" style="height: min-content">
        Share slides in {{ props.service.integration_name }}
      </h4>
    </div>
    <button class="close-btn" @click="close">✕</button>
  </header>
  <section class="is-flex is-flex-direction-column mb-4">
    <Spinner v-if="isLoading" class="is-align-self-center" />
    <div v-else>
      <p class="has-text-dark mb-3">What channel do you want to send this to? You can pick an existing
        channel.</p>
      <div class="control has-icons-left mb-3">
        <div class="select" style="width: 100%;--bulma-arrow-color: #888">
          <select style="width: 100%" v-model="selectedChannel">
            <option disabled value="">Select a Channel</option>
            <option v-for="channel in channels" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
          </select>
        </div>
        <div class="icon is-small is-left">
          <font-awesome-icon icon="hashtag" />
        </div>
      </div>
      <div class="field mb-3" style="width: 100%;">
        <label class="label has-text-dark">Message (optional)</label>
        <div class="control">
          <textarea v-model="message" class="textarea" placeholder=""></textarea>
        </div>
      </div>
    </div>
  </section>
  <footer class="is-flex is-justify-content-flex-end has-background-white">
    <div class="buttons ">
      <button class="button" @click="close">Cancel</button>
      <button
        class="button is-success"
        :class="{'is-loading': isButtonLoading}"
        :disabled="isLoading || isButtonLoading"
        style="background-image: linear-gradient(45deg, #E100FF 0%, #7F00FF 100%); color: white; border: none;--bulma-loading-color:white"
        @click="shareSlide"
      >
        Share in {{ props.service.integration_name }}
      </button>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted } from 'vue';
import Spinner from '../Spinner.vue';

const COLLABORA_ONLINE_URL = import.meta.env.VITE_COLLABORA_ONLINE_URL;

const props = defineProps(['service'])
const emit = defineEmits(['closed'])

// State
const isLoading = ref(true); // Controls the loading spinner
const isButtonLoading = ref(false); // Controls the loading spinner
const channels = ref([]); // List of Slack channels
const selectedChannel = ref(''); // Selected channel ID
const message = ref(''); // Optional message
const error = ref(null); // Stores any error message
let imageData = null;

onMounted(() => {
  initialize();
});

async function initialize() {
  try {
    // Add event listener for messages from the iframe
    window.addEventListener('message', handleMessageEvent);

    document.getElementById("coolframe").contentWindow.postMessage(JSON.stringify({
      "MessageId": "CallPythonScript",
      "SendTime": Date.now(),
      "ScriptFile": "ExportSlide.py",
      "Function": "export_current_slide",
      "Values": {}
    }), COLLABORA_ONLINE_URL);

    const apiResponse = await fetchSlackChannels();

    const [iframeResponse] = await Promise.all([
      new Promise((resolve) => {
        const interval = setInterval(() => {
          if (imageData) {
            clearInterval(interval);
            resolve(imageData);
          }
        }, 100);
      }),
      apiResponse
    ]);


    // Check if both requests succeeded
    if (iframeResponse && apiResponse) {
      channels.value = await apiResponse.json()
      isLoading.value = false; // Hide the spinner
    }
  } catch (error) {
    console.error('Error initializing modal:', error);
    isLoading.value = false; // Hide the spinner even if there's an error
  }
}

// Handle message event from iframe
function handleMessageEvent(event) {
  var msg = JSON.parse(event.data);
  if (
    msg.MessageId === "CallPythonScript-Result"
    && msg.Values.commandName.startsWith("vnd.sun.star.script:ExportSlide.py$export_current_slide")
    && msg.Values.success
  ) {

    const response = JSON.parse(msg.Values.result.value);
    if (response.status) {
      imageData = response.image.data;
    }
  }
}

// Simulate API request to fetch Slack channels
async function fetchSlackChannels() {
  try {
    error.value = null;

    // Replace with your actual API endpoint
    const response = await fetch('https://6vpw8qb6ya.execute-api.eu-north-1.amazonaws.com/dev/slack/fetch-channels');
    return response;
    /* if (!response.ok) {
     *   throw new Error('Failed to fetch channels');
     * }

     * const data = await response.json();
     * channels.value = data.channels; // Assuming the API returns { channels: [...] } */
  } catch (err) {
    console.error('Error fetching channels:', err);
    error.value = 'Failed to load channels. Please try again.';
  } finally {
    isLoading.value = false;
  }
}

function shareSlide() {
  isButtonLoading.value = true;
  const jsonData = {
    "channelId": selectedChannel.value,
    "message": message.value,
    "image": imageData
  };
  const request = new Request('https://8d6kag87r8.execute-api.eu-north-1.amazonaws.com/dev/slack/post-slide', {
    method: "POST",
    body: JSON.stringify(jsonData),
  });
  fetch(request)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then((data) => {
      data = JSON.parse(data);
      const replacementTextData = data.body;
      console.log(JSON.stringify(replacementTextData));
      close();
    });
}

function close() {
  emit('closed');
}

</script>
